import type { JSONContent } from '@tiptap/core';
import { convertCustomIconNodesToText, convertEmojiNodesToText, convertMathNodesToText } from '../processors';

/** Apply all common node-to-text processors (used when serializing tiptap -> markdown). */
export function applyNodeToTextProcessors(node: JSONContent): JSONContent {
  return convertCustomIconNodesToText(convertEmojiNodesToText(convertMathNodesToText(node)));
}
